export const louiseBotImageUrl =
  "https://cdn.1cdn.app/application/LOUISEBOT/2312171433313_Ellipse_980.png";

export const advancedPopoverImageUrl =
  "https://cdn.1cdn.app/application/LOUISEBOT/24120308072691_page_text_chatbot_fully_customizable_to_reflect_your_brand.png";

export const activeWidgetAudioLinks: any = {
  en: "https://cdn.1cdn.app/application/LOUISEBOT/24012220271370_en.mp3",
  fr: "https://cdn.1cdn.app/application/LOUISEBOT/24012220271315_fr.mp3"
};

export const activeExtensionAudioLinks: any = {
  en: "https://cdn.1cdn.app/application/LOUISEBOT/24012220294032_en.mp3",
  fr: "https://cdn.1cdn.app/application/LOUISEBOT/24012220294042_fr.mp3"
};

export const consumedSessionsAudioLinks: any = {
  en: "https://cdn.1cdn.app/application/LOUISEBOT/24012220305882_en.mp3",
  fr: "https://cdn.1cdn.app/application/LOUISEBOT/24012220305825_fr.mp3"
};

export const cloneAudioLinks: any = {
  en: "https://cdn.1cdn.app/application/LOUISEBOT/24012220314244_en.mp3",
  fr: "https://cdn.1cdn.app/application/LOUISEBOT/24012220314228_fr.mp3"
};

export const kbAssistantAudioLinks: any = {
  en: "https://cdn.1cdn.app/application/LOUISEBOT/24012220321057_en.mp3",
  fr: "https://cdn.1cdn.app/application/LOUISEBOT/24012220321080_fr.mp3"
};

export const aiAssistantAudioLinks: any = {
  en: "https://cdn.1cdn.app/application/LOUISEBOT/24012220332675_en.mp3",
  fr: "https://cdn.1cdn.app/application/LOUISEBOT/24012220332678_fr.mp3"
};

export const textScenarioAudioLinks: any = {
  en: "https://cdn.1cdn.app/application/LOUISEBOT/24012220330244_en.mp3",
  fr: "https://cdn.1cdn.app/application/LOUISEBOT/24012220330262_fr.mp3"
};

export const videoScenarioAudioLinks: any = {
  en: "https://cdn.1cdn.app/application/LOUISEBOT/24012220483765_en.mp3",
  fr: "https://cdn.1cdn.app/application/LOUISEBOT/24012220483744_fr.mp3"
};

export const myBotsAudioLinks: any = {
  en: "https://cdn.1cdn.app/application/LOUISEBOT/24012220490332_en.mp3",
  fr: "https://cdn.1cdn.app/application/LOUISEBOT/24012220490393_fr.mp3"
};

export const extensionsAudioLinks: any = {
  en: "https://cdn.1cdn.app/application/LOUISEBOT/24012220493519_en.mp3",
  fr: "https://cdn.1cdn.app/application/LOUISEBOT/24012220493535_fr.mp3"
};

export const personalUsageAudioLinks: any = {
  en: "https://cdn.1cdn.app/application/LOUISEBOT/2401222050019_en.mp3",
  fr: "https://cdn.1cdn.app/application/LOUISEBOT/24012220500135_fr.mp3"
};

export const inWebsiteAudioLinks: any = {
  en: "https://cdn.1cdn.app/application/LOUISEBOT/24022808145287_publish_chatbot-en.mp3",
  fr: "https://cdn.1cdn.app/application/LOUISEBOT/24022808145250_publish_chatbot-fr.mp3"
};

export const useAsExtensionAudioLinks: any = {
  en: "https://cdn.1cdn.app/application/LOUISEBOT/24060406065270_humain_clone_tooltips_en.mp3",
  fr: "https://cdn.1cdn.app/application/LOUISEBOT/24060406065277_humain_clone_tooltips_fr.mp3"
};

export const ppAssistantAudioLinks: any = {
  en: "https://cdn.1cdn.app/application/LOUISEBOT/24022814011278_plug_and_play_en.mp3",
  fr: "https://cdn.1cdn.app/application/LOUISEBOT/24022814011219_plug_and_play_fr.mp3"
};
